import { render, staticRenderFns } from "./FormActions.vue?vue&type=template&id=a33191d2&"
import script from "./FormActions.vue?vue&type=script&lang=js&"
export * from "./FormActions.vue?vue&type=script&lang=js&"
import style0 from "./FormActions.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/modules/shared/ui/public/forms/components/FormActions.vue
// module id = 254
// module chunks = 0